// Data kurzů GAVITO technic s.r.o.
// videoUrl: nahraďte odkazem na video z Cloudflare R2 streamingu (přímý .mp4 odkaz).
// dotovany: true = kurz s příspěvkem Úřadu práce (min. 50 h výuky, spoluúčast min. 23,27 %).
// Cena vychází z ~950 Kč / hodina výuky.

export const SPOLUUCAST_PCT = 0.2327; // minimální zákonná spoluúčast 23,27 %

export const courses = [
  {
    slug: "skola-nove-generace",
    title: "ŠKOLA NOVÉ GENERACE: Pokročilé digitální technologie v pedagogické praxi a řízení školy",
    dotovany: true,
    forma: "Prezenční / Online",
    delka: "50 hodin",
    cena: 45613,
    prispevekUP: 35000,
    spoluucast: 10613,
    videoUrl: null,
    videoEmbed:
      "https://customer-gcuxez6n2j23rqqn.cloudflarestream.com/e084934be3d2b8f1079061abef433386/iframe?poster=https%3A%2F%2Fcustomer-gcuxez6n2j23rqqn.cloudflarestream.com%2Fe084934be3d2b8f1079061abef433386%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600",
    kratkyPopis:
      "Intenzivní prakticky orientovaný kurz pro pedagogy, ředitele a vedoucí pracovníky škol – digitální transformace výuky i řízení školy.",
    popis:
      "Intenzivní prakticky orientovaný kurz určený pedagogickým pracovníkům, ředitelům a dalším vedoucím pracovníkům škol, kteří chtějí získat náskok v oblasti pokročilých digitálních technologií. Účastníci si osvojí práci s inteligentními digitálními nástroji pro automatizované generování výukového obsahu, tvorbu multimediálních materiálů, pokročilou analýzu dat a automatizaci administrativních i řídicích procesů školy. Kurz provede účastníky celou digitální transformací školního prostředí – od modernizace přípravy výuky přes efektivní hodnocení žáků až po strategické řízení a rozvoj vzdělávací instituce. Výuka probíhá formou praktických workshopů na reálných situacích ze školního prostředí, takže si účastníci veškeré postupy ihned ověří na vlastních úlohách ze své praxe. Nedílnou součástí je problematika ochrany osobních údajů žáků, kybernetické bezpečnosti a právního a etického rámce nasazení pokročilých technologií ve školství.",
    naucite: [
      "Automatizovaně generovat výukové materiály, pracovní listy a testy",
      "Tvořit multimediální výukový obsah – grafiku, videa i prezentace",
      "Automatizovat administrativu a řízení školy",
      "Nasazovat technologie bezpečně a v souladu s GDPR a etikou",
    ],
    urcenoPro: "Pedagogické pracovníky, ředitele a vedoucí pracovníky škol.",
    osnova: [
      { skupina: "Digitální transformace školy nové generace", body: [
        "Aktuální technologické trendy měnící podobu vzdělávání",
        "Digitální kompetence pedagoga a lídra školy (rámec DigCompEdu)",
        "Strategie digitální transformace instituce a analýza potřeb",
      ]},
      { skupina: "Inteligentní tvorba výukového obsahu", body: [
        "Automatizované generování výukových materiálů, pracovních listů a testů",
        "Personalizace výuky a diferenciace úloh podle potřeb žáků",
        "Pokročilá digitální podpora žáků se specifickými vzdělávacími potřebami",
      ]},
      { skupina: "Pokročilé konverzační platformy v pedagogické praxi", body: [
        "Praktické zvládnutí inteligentních konverzačních nástrojů",
        "Pokročilé techniky zadávání požadavků pro vzdělávací účely",
        "Kritické ověřování správnosti, kvality a spolehlivosti výstupů",
      ]},
      { skupina: "Profesionální multimediální produkce pro výuku", body: [
        "Generativní tvorba grafiky, ilustrací a názorných pomůcek",
        "Produkce výukových videí a audio materiálů",
        "Interaktivní prezentace a dynamické výukové aktivity",
      ]},
      { skupina: "Automatizace řízení a administrativy školy", body: [
        "Automatizace administrativních a organizačních procesů",
        "Inteligentní tvorba dokumentů, směrnic a strategických podkladů",
        "Moderní digitální komunikace s rodiči, zřizovatelem a veřejností",
      ]},
      { skupina: "Datově řízená škola: hodnocení a analýza", body: [
        "Pokročilé digitální nástroje pro hodnocení a zpětnou vazbu žákům",
        "Analýza vzdělávacích výsledků a datově podložené rozhodování",
        "Formativní hodnocení s podporou inteligentních technologií",
      ]},
      { skupina: "Bezpečnost a odpovědné nasazení technologií", body: [
        "GDPR a ochrana osobních údajů žáků při práci s pokročilými nástroji",
        "Kybernetická bezpečnost ve školním prostředí",
        "Etický a právní rámec využívání pokročilých digitálních technologií ve školství",
      ]},
      { skupina: "Závěrečný transformační projekt", body: [
        "Zpracování vlastního projektu digitální inovace z praxe účastníka",
        "Prezentace, zpětná vazba a strategie dalšího rozvoje",
      ]},
    ],
  },
  {
    slug: "ai-mistrovstvi-pro-pedagogy",
    title: "AI MISTROVSTVÍ PRO PEDAGOGY A VEDENÍ ŠKOL",
    dotovany: true,
    forma: "Prezenční / Online",
    delka: "50 hodin",
    cena: 45613,
    prispevekUP: 35000,
    spoluucast: 10613,
    videoUrl: null,
    videoEmbed:
      "https://customer-gcuxez6n2j23rqqn.cloudflarestream.com/bf0734856ad7184188a1a78782d60a73/iframe?poster=https%3A%2F%2Fcustomer-gcuxez6n2j23rqqn.cloudflarestream.com%2Fbf0734856ad7184188a1a78782d60a73%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600",
    videoAspect: 100,
    kratkyPopis:
      "Odborný kurz pro pedagogy a vedení škol o tom, jak didakticky, hodnotově i organizačně odpovědět na skutečnost, že žáci umělou inteligenci už aktivně používají.",
    popis:
      "Odborný kurz určený pedagogickým pracovníkům, ředitelům a dalším vedoucím pracovníkům škol, který se zaměřuje na zásadní výzvu současného školství: žáci umělou inteligenci již aktivně používají a škola na to musí odpovědět – didakticky, hodnotově i organizačně. Na rozdíl od kurzů zaměřených na používání digitálních nástrojů pro vlastní produktivitu se tento kurz věnuje AI jako fenoménu, který mění samotný obsah a smysl vzdělávání. Účastníci si osvojí didaktické přístupy k výuce s umělou inteligencí a o umělé inteligenci: jak rozvíjet AI gramotnost a kritické myšlení žáků, jak navrhovat výukové aktivity, ve kterých AI podporuje učení místo aby ho nahrazovala, a jak proměnit zadávání úkolů a hodnocení v situaci, kdy mají žáci AI trvale k dispozici. Zvládnou nastavit srozumitelná pravidla používání AI žáky, rozpoznávat rizika nekritického přejímání AI výstupů a pracovat s tématy akademické integrity a duševního vlastnictví ve výuce. Účastníci se také prakticky seznámí s automatizací opakovaných procesů ve školním prostředí – od automatizované zpětné vazby žákům přes komunikační workflow až po organizační agendu – a naučí se posoudit, které procesy automatizovat lze a kde musí zůstat lidský úsudek nezastupitelný. Vedoucí pracovníci si nad rámec didaktické roviny osvojí metodiku řízení této změny na úrovni instituce: tvorbu vnitřních pravidel a směrnic pro používání AI žáky i zaměstnanci, plánování profesního rozvoje sboru, práci s obavami a rezistencí pedagogů, komunikaci vůči rodičům a zřizovateli a přípravu školy na legislativní požadavky včetně evropského aktu o umělé inteligenci (AI Act). Kurz pokrývá také ochranu osobních údajů žáků dle GDPR a governance rámec odpovědného nasazení AI ve vzdělávací instituci. Výuka probíhá formou praktických workshopů a případových studií ze školního prostředí – pedagogové odcházejí s konkrétními výukovými aktivitami a proměněnými způsoby zadávání a hodnocení, vedoucí pracovníci s konceptem pravidel používání AI pro svou školu.",
    naucite: [
      "Didakticky učit s AI i o AI a rozvíjet AI gramotnost a kritické myšlení žáků",
      "Proměnit zadávání úkolů a hodnocení v situaci, kdy žáci mají AI trvale k dispozici",
      "Nastavit srozumitelná pravidla a vnitřní směrnice pro používání AI ve škole",
      "Automatizovat opakované procesy školy a řídit změnu v pedagogickém sboru",
    ],
    urcenoPro: "Pedagogické pracovníky, ředitele a vedoucí pracovníky škol.",
    osnova: [
      { skupina: "AI jako výzva pro současnou školu", body: [
        "Jak žáci reálně používají AI: data, trendy, dopady na učení",
        "Co AI mění na smyslu vzdělávání: kompetence pro éru AI",
        "Východiska: rámec DigCompEdu a AI gramotnost",
      ]},
      { skupina: "AI gramotnost žáků a kritické myšlení", body: [
        "Jak AI funguje a kde chybuje: srozumitelně pro žáky všech stupňů",
        "Rozvoj kritického vyhodnocování AI výstupů žáky",
        "Rizika: dezinformace, halucinace AI, algoritmické zkreslení",
      ]},
      { skupina: "Didaktika výuky s AI", body: [
        "Výukové aktivity, ve kterých AI podporuje učení, nikoli nahrazuje",
        "AI jako partner pro dialog, zpětnou vazbu a procvičování",
        "Diferenciace a podpora žáků se specifickými potřebami",
      ]},
      { skupina: "Zadávání úkolů v éře AI", body: [
        "Proměna úkolů: zadání, která mají smysl, i když žák má AI",
        "Návrh úloh rozvíjejících vlastní myšlení a tvořivost žáků",
        "Práce s AI jako přiznanou součástí řešení úkolu",
      ]},
      { skupina: "Hodnocení a akademická integrita", body: [
        "Hodnocení procesu učení místo pouhého výsledku",
        "Akademická integrita: pravidla, prevence, práce s porušením",
        "Duševní vlastnictví a citační etika ve výuce s AI",
      ]},
      { skupina: "Pravidla používání AI ve škole", body: [
        "Tvorba srozumitelných pravidel pro žáky: co, kdy a jak smí",
        "Vnitřní směrnice pro zaměstnance školy",
        "Zapojení žáků, sboru a rodičů do tvorby pravidel",
      ]},
      { skupina: "Automatizace procesů ve školním prostředí", body: [
        "Které školní procesy automatizovat lze a kde je lidský úsudek nezastupitelný",
        "Automatizované workflows ve výuce a zpětné vazbě žákům a rodičům",
        "Automatizace komunikační a organizační agendy školy",
        "Návrh jednoduché automatizace bez nutnosti programování",
      ]},
      { skupina: "Řízení změny v pedagogickém sboru", body: [
        "Práce s obavami a rezistencí pedagogů vůči AI",
        "Plánování profesního rozvoje sboru v oblasti AI",
        "Sdílení praxe: interní mentoring a podpora mezi kolegy",
      ]},
      { skupina: "Škola, rodiče a veřejnost", body: [
        "Komunikace přístupu školy k AI vůči rodičům a zřizovateli",
        "Transparentnost: kdy a jak škola AI používá",
        "Budování důvěry v odpovědný přístup instituce",
      ]},
      { skupina: "Právní a etický rámec AI ve školství", body: [
        "Ochrana osobních údajů žáků dle GDPR při práci s AI",
        "Evropský akt o umělé inteligenci (AI Act) a jeho dopady na školy",
        "Governance: odpovědnost, dokumentace, vyhodnocování dopadů",
      ]},
    ],
  },
  {
    slug: "strategicke-vyuziti-ai",
    title: "Strategické využití AI pro profesní růst",
    dotovany: false,
    forma: "Online",
    delka: "40 hodin",
    cena: 38000,
    videoUrl: null,
    kratkyPopis:
      "Naučte se využívat umělou inteligenci strategicky – pro rozhodování, plánování a rozvoj vaší kariéry.",
    popis:
      "Kurz zaměřený na pokročilé a strategické využití AI nástrojů. Ukážeme vám, jak AI zapojit do plánování, rozhodování, tvorby obsahu a osobního rozvoje tak, abyste získali reálnou konkurenční výhodu ve své profesi.",
    naucite: [
      "Navrhnout vlastní AI pracovní postupy",
      "Využít AI pro analýzu a rozhodování",
      "Tvořit obsah a strategie s pomocí AI",
      "Sledovat trendy a nové nástroje",
    ],
    urcenoPro: "Profesionály, manažery a OSVČ, kteří chtějí posunout svou kariéru.",
  },
  {
    slug: "digitalni-dovednosti",
    title: "Digitální dovednosti pro každodenní život",
    dotovany: false,
    forma: "Prezenční",
    delka: "30 hodin",
    cena: 28500,
    videoUrl: null,
    kratkyPopis:
      "Základní digitální gramotnost srozumitelně a bez stresu – ideální pro začátečníky i seniory.",
    popis:
      "Kurz vás provede základy práce s počítačem, chytrým telefonem a internetem. Naučíte se používat e‑mail, vyhledávat informace, pracovat s online službami státní správy a bezpečně nakupovat online. Vše vysvětlujeme trpělivě a srozumitelně, vlastním tempem.",
    naucite: [
      "Ovládat počítač, tablet a chytrý telefon",
      "Používat e‑mail a komunikační aplikace",
      "Bezpečně vyhledávat a nakupovat na internetu",
      "Využívat online služby (Portál občana, bankovnictví)",
    ],
    urcenoPro: "Začátečníky, seniory a všechny, kdo si chtějí osvojit základní digitální dovednosti.",
  },
  {
    slug: "kyberneticka-bezpecnost",
    title: "Kybernetická bezpečnost a ochrana osobních údajů",
    dotovany: false,
    forma: "Online",
    delka: "24 hodin",
    cena: 23000,
    videoUrl: null,
    kratkyPopis:
      "Naučte se chránit sebe i svá data před podvody, viry a úniky informací v online světě.",
    popis:
      "Praktický kurz kybernetické bezpečnosti pro běžné uživatele. Ukážeme vám, jak rozpoznat phishing a podvodné e‑maily, jak si vytvořit silná hesla, používat dvoufázové ověření a bezpečně zacházet s osobními údaji podle zásad GDPR.",
    naucite: [
      "Rozpoznat phishing, podvody a škodlivý software",
      "Vytvářet a spravovat bezpečná hesla",
      "Nastavit dvoufázové ověření a zálohování",
      "Chránit osobní údaje v souladu s GDPR",
    ],
    urcenoPro: "Všechny uživatele internetu, kteří chtějí bezpečně pracovat online.",
  },
  {
    slug: "firemni-skoleni-na-miru",
    title: "Firemní školení na míru",
    dotovany: false,
    forma: "Prezenční / Online",
    delka: "dle domluvy",
    cena: null,
    videoUrl: null,
    kratkyPopis:
      "Sestavíme vzdělávací program přesně podle potřeb vaší firmy a vašeho týmu.",
    popis:
      "Komerční školení připravené na míru vaší organizaci. Obsah, rozsah i formu přizpůsobíme vašim cílům – od digitálních dovedností přes AI nástroje až po kybernetickou bezpečnost. Ozvěte se nám a připravíme nezávaznou nabídku.",
    naucite: [
      "Program sestavený dle vašich potřeb",
      "Výuka u vás ve firmě nebo online",
      "Praktická cvičení na reálných příkladech",
      "Flexibilní termíny i rozsah",
    ],
    urcenoPro: "Firmy a organizace, které chtějí vzdělávat své týmy.",
  },
];

export const getCourseBySlug = (slug) => courses.find((c) => c.slug === slug);

export const formatCZK = (n) =>
  new Intl.NumberFormat("cs-CZ", { style: "currency", currency: "CZK", maximumFractionDigits: 0 }).format(n);
